<template>
  <div>
    <vs-card>
      <b-row>
        <b-col>
          <b-row align-v="end">
            <b-col cols="3">
              <b-form-group label="Pazaryeri" label-for="item-name">
                <v-select
                  v-model="selectedMp"
                  label="name"
                  :options="optionsMp"
                  autocomplete
                  :taggable="true"
                ></v-select>
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <b-row>
                <b-col
                  :cols="loadingStokListValidate == true ? '2' : '0'"
                  v-if="loadingStokListValidate == true"
                >
                  <div
                    style="width: 100%; height: 100%"
                    id="loading-barcode"
                    class="vs-con-loading__container"
                  ></div>
                </b-col>
                <b-col
                  :cols="loadingStokListValidate == true ? '10' : '12'"
                  align-self="center"
                >
                  <b-form-group label="Pazaryeri Barkod" label-for="item-name">
                    <v-select
                      v-model="stokListInput"
                      label="Barkod"
                      :options="stokListesi"
                      :taggable="true"
                      autocomplete
                      @search="getStokList"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>

            <b-col cols="3">
              <b-row>
                <b-col
                  :cols="loadingXmlStokListValidate == true ? '2' : '0'"
                  v-if="loadingXmlStokListValidate == true && ekYetkiler == 'xmlStok'"
                >
                  <div class="demo-alignment">
                    <div class="fill-row-loading" style="margin: 0px !important">
                      <div
                        :class="{ activeLoading: activeLoading }"
                        :id="[`loading-${types[1]}-1`]"
                        style="width: 50px; height: 50px"
                        class="vs-con-loading__container"
                      ></div>
                    </div>
                  </div>
                </b-col>
                <b-col
                  :cols="loadingXmlStokListValidate == true ? '10' : '12'"
                  align-self="center"
                  ><b-form-group label="Tedarikçi Barkod" label-for="item-name">
                    <v-select
                      v-model="xmlStokListInput"
                      label="barkod"
                      :options="xmlStokListesi"
                      autocomplete
                      :taggable="true"
                    ></v-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>

            <b-col cols="3">
              <b-row class="justify-content-md-start">
                <b-col cols="12" md="auto">
                  <b-button
                    style="background-color: #28c76f; border-color: #28c76f"
                    v-on:click="stokKoduEslestir(0)"
                    id="loading-eslestir"
                    class="vs-con-loading__container"
                  >
                    <Icon
                      style="margin-right: 5px"
                      icon="ph:git-merge"
                      width="20"
                      height="20"
                      v-b-tooltip.hover.bottom="'Eşleştir'"
                    />Eşleştir
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="mt-5">
            <b-col>
              <b-row class="justify-content-md-start">
                <b-col cols="12" md="auto">
                  <b-button
                    style="background-color: #ea5455; border-color: #ea5455"
                    v-on:click="otomatikStokKoduEslestir()"
                    id="loading-eslestir-oto"
                    class="vs-con-loading__container"
                  >
                    <Icon
                      style="margin-right: 5px"
                      icon="ph:git-merge-fill"
                      width="20"
                      height="20"
                    />Otomatik Stok Eşleştir
                  </b-button>
                </b-col>
                <b-col cols="12" md="auto">
                  <b-button
                    style="background-color: #ff9f43; border-color: #ff9f43"
                    v-on:click="stokKoduEslestirListe()"
                    id="loading-eslestir"
                    class="vs-con-loading__container"
                  >
                    <Icon
                      style="margin-right: 5px"
                      icon="clarity:list-line"
                      width="20"
                      height="20"
                    />Eşlenen Stok Listesi
                  </b-button>
                </b-col>

                <b-col cols="12" md="auto">
                  <b-button
                    class="bg-primary"
                    style="border-color: white; width: 100%"
                    v-on:click="isSidebarActiveAddWithExcel = true"
                  >
                    <Icon icon="icon-park-outline:excel" width="20" height="20" />
                    Excel İle Ekle</b-button
                  >
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col></b-row
      >
      <b-row> </b-row>
    </vs-card>
    <vs-card>
      <ag-grid-vue
        style="width: 100%; height: 400px; margin-top: 15px"
        class="ag-theme-alpine"
        :enableCellChangeFlash="true"
        :animateRows="true"
        :defaultColDef="defaultColDef"
        :columnDefs="ekYetkiler == 'xmlStok' ? columnDefsXml : columnDefsMarketplace"
        :rowData="ekYetkiler == 'xmlStok' ? xmlStokListesi : stokListesi"
        :localeText="localeText"
        :suppressCopyRowsToClipboard="true"
        :pagination="true"
        @grid-ready="onGridReady"
        @first-data-rendered="onFirstDataRendered"
      >
      </ag-grid-vue>
    </vs-card>
    <vs-popup
      class="holamundo"
      title="Excel İle Ekle"
      :active.sync="isSidebarActiveAddWithExcel"
      @close="closeExcelAddPopup"
      @cancel="closeExcelAddPopup"
      fullscreen
    >
      <vs-prompt
        title="Onayla"
        acceptText="Kaydet"
        cancelText="İptal"
        @accept="addProductWithExcel"
        :active.sync="activePromptToProduct"
      >
        <div class="con-exemple-prompt">
          <b-row style="align-items: center">
            <b-col lg="12">
              <span>Onaylıyor musunuz?</span>
            </b-col>
          </b-row>
        </div>
      </vs-prompt>

      <b-row>
        <b-col lg="6">
          <vs-card>
            <b-row class="mb-8 mt-8">
              <UploadBtnDynamic :isUploaded="isUploadedAddExcel" />
            </b-row>
            <b-row class="justify-content-md-end">
              <b-col cols="12" md="auto" class="ml-2" style="padding: 0px">
                <b-button
                  class="bg-danger"
                  style="border-color: white"
                  v-on:click="clearAddExcel()"
                >
                  <Icon
                    icon="material-symbols:cancel-outline"
                    style="margin-right: 5px"
                    width="20"
                    height="20"
                  />{{ $t("Cancel") }}
                </b-button>
              </b-col>
              <b-col cols="12" md="auto" style="padding: 0px">
                <b-button
                  class="bg-success"
                  style="border-color: white"
                  v-on:click="downloadSampleAddExcel()"
                >
                  {{ $t("SampleExcel") }}</b-button
                >
              </b-col>
              <b-col cols="12" md="auto" style="padding: 0px">
                <b-button
                  class="bg-primary"
                  style="border-color: white"
                  v-on:click="activePromptToProduct = true"
                >
                  Ekle
                </b-button></b-col
              >
            </b-row>
          </vs-card>
          <span v-if="excelErrors.length > 0"> {{ excelErrors }}</span>
        </b-col>
        <b-col>
          <b-row>
            <b-col>
              <vs-card>
                <ag-grid-vue
                  style="width: 100%; height: 400px"
                  class="ag-theme-alpine"
                  :suppressRowClickSelection="true"
                  :defaultColDef="defaultColDef"
                  :columnDefs="excelListColumnAdd"
                  :rowData="wholeAcceptedProductListAddExcel"
                  :localeText="localeText"
                  @grid-ready="onGridReady"
                >
                </ag-grid-vue>
              </vs-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </vs-popup>
    <b-modal
      ref="modal-resim"
      id="modal-primary"
      modal-class="modal-primary"
      size="sm"
      centered
      title="BootstrapVue"
      hide-footer
      hide-header
    >
      <img :src="imageLink" style="width: 100%" />
    </b-modal>
    <b-modal
      ref="modal-stoklistdetay"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      title="Stok Eşleştir"
      size="xl"
      hide-footer
    >
      <vs-card>
        <b-row class="justify-content-md-start">
          <b-col cols="3">
            <b-form-group label-for="item-name">
              <b-form-input
                v-model="aranan"
                id="smallInput"
                placeholder="Ara.."
                @keyup.enter="stokKoduEslemeListesi"
                size="sm"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="auto" style="padding-left: 0px !important">
            <b-button
              style="background-color: #7367f0; border-color: white"
              size="sm"
              v-on:click="stokKoduEslemeListesi()"
            >
              <Icon
                icon="material-symbols:search-rounded"
                width="20"
                height="20"
              /> </b-button
          ></b-col>
        </b-row>

        <ag-grid-vue
          style="width: 100%; height: 400px; margin-top: 15px"
          class="ag-theme-alpine"
          :defaultColDef="defaultColDef"
          :columnDefs="columnDefs"
          :rowData="rowdata"
          :localeText="localeText"
          :suppressCopyRowsToClipboard="true"
          :pagination="true"
          @grid-ready="onGridReady"
          @first-data-rendered="onFirstDataRendered"
        >
        </ag-grid-vue>
      </vs-card>
      <vs-divider></vs-divider>
    </b-modal>

    <b-modal
      ref="modal-stokEkle"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      :title="stokTitle"
      size="xl"
      hide-footer
    >
      <div style="min-height: 350px">
        <vs-card>
          <ag-grid-vue
            style="width: 100%; height: 400px; margin-top: 15px"
            class="ag-theme-alpine"
            :defaultColDef="defaultColDef"
            :columnDefs="columnDefsMarketplace"
            :rowData="stokListesi"
            :localeText="localeText"
            :suppressCopyRowsToClipboard="true"
            :pagination="true"
            @grid-ready="onGridReady"
            @first-data-rendered="onFirstDataRendered"
          >
          </ag-grid-vue>
        </vs-card>
      </div>
    </b-modal>

    <b-modal
      ref="modal-stokEsle"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      size="md"
      hide-footer
      :title="stokTitle"
    >
      <div style="min-height: 350px">
        <vs-card>
          <v-select
            v-model="selectedMp"
            label="name"
            :options="optionsMp"
            autocomplete
            :taggable="true"
          ></v-select>
          <b-form-input
            size="sm"
            v-model="barkodSecilen"
            @keyup.enter="stokKoduEslestir(1)"
            id="smallInput"
            placeholder="Barkod"
            style="margin-top: 25px"
          />
          <div slot="footer">
            <vs-row vs-justify="flex-end">
              <b-button
                style="background-color: #28c76f; border-color: #28c76f"
                v-on:click="stokKoduEslestir(1)"
              >
                <Icon
                  style="margin-right: 5px"
                  icon="mdi:content-save-check-outline"
                  width="20"
                  height="20"
                  v-b-tooltip.hover.bottom="'Kampanya oluştur'"
                />Kaydet
              </b-button>
            </vs-row>
          </div>
        </vs-card>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
import state from "../../store/state";
import Store from "../../store/store";
import vSelect from "vue-select";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import StokEslestirButon from "../components/uzum-components/stoklistesi-components/StokEslestirButon.vue";
import TextGorunumCellRenderer from "./CellRenderers/TextGorunumCellRenderer.vue";
import StokListButon from "../components/uzum-components/stoklistesi-components/StokListButon.vue";
import StokSecButon from "../components/uzum-components/stoklistesi-components/StokSecButon.vue";
import UploadBtnDynamic from "../components/uzum-components/UploadBtnDynamic.vue";
export default {
  data() {
    return {
      localSelectedValue: "",
      excelListColumnAdd: [],
      activePromptToProduct: false,
      excelErrors: [],
      wholeAcceptedProductListAddExcel: [],
      isUploadedAddExcel: false,
      isSidebarActiveAddWithExcel: false,
      secilenStokBarcode: "",
      barkodSecilen: "",
      optionsMp: [],
      selectedMp: "",
      ekYetkiler: "",
      secilenMarketplaceStok: [],
      secilenXmlStok2: [],
      stokTitle: "",
      imageLink: "",
      girilenStok: "",
      girilenstokM: "",
      items: ["one", "two", "three"],
      selected: "one",
      searchInput: "",
      currentGelenPage: 1,
      pageLength: 50,
      KAYITSAYISI: 0,
      aranan: "",
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      columnDefs: [],
      localeText: null,
      rowdata: null,
      secilenPazaryeri: "",
      tabList: [],
      secilenXmlStok: "",
      secilenXmlStokb: "",
      secilenStok: "",
      stokListesi: [],
      xmlStokListesi: [],
      types: ["material", "material"],
      activeLoading: false,
      durumlist: "",
      loadingStokListValidate: true,
      loadingXmlStokListValidate: true,
      xmlStokListInput: [],
      stokListInput: [],
      secilenXmlStokFirma: "",
    };
  },
  components: {
    UploadBtnDynamic,
    Icon,
    StokEslestirButon,
    TextGorunumCellRenderer,
    AgGridVue,
    "v-select": vSelect,
    StokListButon,
    StokSecButon,
  },
  watch: {
    searchInput(val) {
      alert(val);
    },
  },

  mounted() {
    let type = "material";
    setTimeout(() => {
      this.$vs.loading({
        container: `#loading-barcode`,
        type,
        scale: 0.5,
      });
    }, 1000);
    this.$root.$on("excelData", (paramDetail) => {
      if (paramDetail) this.isUploadedAddExcel = true;
      this.wholeAcceptedProductListAddExcel = paramDetail;
      this.setItem();
    });
    this.$root.$on("getStokSecMarketplace", (stokDetayVal) => {
      this.secilenMarketplaceStok = stokDetayVal;
      this.getStokSecMarketplace(stokDetayVal);
    });
    this.$root.$on("getStokResim", (stokDetayVal) => {
      this.getStokResim(stokDetayVal);
    });
    this.$root.$on("deleteEslesenStok", (stokDetayVal) => {
      this.deleteEslesenStok(stokDetayVal);
    });
    this.$root.$on("getStokListMarketplace", (stokDetayVal) => {
      this.stokTitle = stokDetayVal.stokKodu + " / " + stokDetayVal.stokName;
      this.secilenXmlStok2 = stokDetayVal;
      this.getStokListMarketplace();
    });
  },
  beforeDestroy() {
    this.$root.$off("excelData");
    this.$root.$off("getStokResim");
    this.$root.$off("deleteEslesenStok");
    this.$root.$off("getStokListMarketplace");
    this.$root.$off("getStokSecMarketplace");
  },
  methods: {
    downloadSampleAddExcel() {
      const link = document.createElement("a");
      link.href = "http://sistem.uzum.com.tr/assets/SampleStockMatchingTemplate.xlsx";
      link.download = "SampleStockMatchingTemplate.xlsx";
      link.click();
    },
    filterStockExcel(index) {
      const vs = this.$vs;
      if (index < 0) {
        vs.notify({
          text: "Eklendi",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
          position: "top-center",
        });
      } else {
        this.addMatchingStock(this.wholeAcceptedProductListAddExcel[index], index);
        index--;
        this.filterStockExcel(index);
      }
    },
    addMatchingStock(item, index) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      let args = {
        token: Store.state.tokenId,
        program: item.program.toString(),
        programBarkod: item.programBarkod.toString(),
        muhasebeBarkod: item.muhasebeBarkod.toString(),
        barkod: item.barkod.toString(),
      };
      soap.createClient(url, function (err, client) {
        client.pazaryeriStokKoduEsleme(args, function (err, result) {
          if (result.pazaryeriStokKoduEslemeResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.pazaryeriStokKoduEslemeResult);
          } catch (error) {
            vm.excelErrors.push({ error: error, item: item });
          }
        });
      });
    },
    addProductWithExcel() {
      const vs = this.$vs;

      if (this.transactionNo == "") {
        vs.notify({
          text: this.$t("InfoTransferNo"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      } else {
        this.filterStockExcel(this.wholeAcceptedProductListAddExcel.length - 1);
      }
    },
    setItem() {
      this.excelListColumnAdd = [];
      let columnList = Object.keys(this.wholeAcceptedProductListAddExcel[0]);
      columnList.forEach((value, index) => {
        this.excelListColumnAdd.push({
          headerName: this.$t(value),
          field: value,
          filter: "agSetColumnFilter",
        });
      });
    },
    clearAddExcel() {
      this.wholeAcceptedProductListAddExcel = [];
      this.isUploadedAddExcel = false;
    },
    closeExcelAddPopup() {
      this.isSidebarActiveAddWithExcel = false;
      this.isUploadedAddExcel = false;
      this.wholeAcceptedProductListAddExcel = [];
    },
    getStokSecMarketplace() {
      if (this.ekYetkiler == "xmlStok") {
        this.secilenXmlStokb = this.secilenXmlStok2.barkod;
        this.secilenXmlStokFirma = this.secilenXmlStok2.firma;
        this.secilenStok = this.secilenMarketplaceStok.stokKodu;
        this.secilenStokBarcode = this.secilenMarketplaceStok.Barkod;
        this.secilenXmlStok = this.secilenXmlStok2.stokKodu;
        this.stokKoduEslestir(1);
      } else {
        this.selectedMp = "";
        this.secilenXmlStokb = this.secilenMarketplaceStok.Barkod;
        this.secilenXmlStok = this.secilenMarketplaceStok.stokKodu;
        this.stokTitle =
          this.secilenMarketplaceStok.Barkod + " " + this.secilenMarketplaceStok.StokAdi;
        this.$refs["modal-stokEsle"].show();
      }
    },
    getStokListMarketplace() {
      this.$refs["modal-stokEkle"].show();
    },
    stokKoduEslestirListe() {
      this.stokKoduEslemeListesi();
      this.$refs["modal-stoklistdetay"].show();
    },
    deleteEslesenStok(data) {
      var vm = this;
      var vs = this.$vs;

      vm.veriler = [];
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        program: data.program,
        barkod: data.barkod,
        programBarkod: data.pazaryeriKod,
      };
      soap.createClient(url, function (err, client) {
        client.pazaryeriStokKoduEslenenSil(args, function (err, result) {
          if (result.pazaryeriStokKoduEslenenSilResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.pazaryeriStokKoduEslenenSilResult);
          if (vm.veriler.response == "Ok") {
            vs.notify({
              title: "Stok Eşleme",
              text: "Silme İşlemi Yapıldı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
            vm.stokKoduEslemeListesi();
          }
        });
      });
    },
    getStokResim(data) {
      var vm = this;
      vm.veriler = [];
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        pazaryeri: "Ticimax",
        stokKodu: data.pazaryeriStokKodu,
      };
      soap.createClient(url, function (err, client) {
        client.resimUrlCek(args, function (err, result) {
          if (result.resimUrlCekResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.resimUrlCekResult);
          vm.imageLink = vm.veriler.jsonData.resimUrl;
          vm.$refs["modal-resim"].show();
        });
      });
    },

    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    stokKoduEslemeListesi() {
      var vs = this.$vs;
      var vm = this;
      vm.veriler = [];
      vm.rowdata = [];
      vm.columnDefs = [];
      let sonkayitcurrentGelenPage = vm.currentGelenPage - 1;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        barkod: vm.aranan,
        ILKKAYIT: vm.pageLength * sonkayitcurrentGelenPage,
        SONKAYIT: vm.pageLength,
      };
      soap.createClient(url, function (err, client) {
        client.pazaryeriStokKoduEslemeListesi(args, function (err, result) {
          if (result.pazaryeriStokKoduEslemeListesiResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.pazaryeriStokKoduEslemeListesiResult);
          let list = vm.veriler;
          let columnList = Object.keys(list[0]);
          vm.columnDefs.push({
            width: 100,
            field: "",
            cellRendererFramework: "StokEslestirButon",
            wrapText: true,
            autoHeight: true,
          });
          columnList.forEach((val, index) => {
            vm.columnDefs.push({
              field: val,
              filter: "agSetColumnFilter",
              wrapText: true,
              autoHeight: true,
              cellRenderer: "TextGorunumCellRenderer",
            });
          });

          vm.rowdata = list;
          if (vm.veriler != "") vm.KAYITSAYISI = vm.veriler[0].KAYITSAYISI;
        });
      });
    },
    otomatikStokKoduEslestir() {
      let type = "radius";

      var vs = this.$vs;
      var vm = this;
      vm.veriler = [];
      vs.loading({
        container: `#loading-eslestir-oto`,
        type,
      });

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
      };
      soap.createClient(url, function (err, client) {
        client.otomatikStokEsleme(args, function (err, result) {
          if (result.otomatikStokEslemeResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.otomatikStokEslemeResult);
            vm.stokKoduEslemeListesi();
            vs.loading.close("#loading-eslestir-oto > .con-vs-loading");
            vs.notify({
              title: "Stok Eşleme",
              text: "Otomatik Stok Eşleme Yapıldı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          } catch (error) {
            vs.notify({
              title: "Stok Eşleme",
              text: "Otomatik Stok Eşleme Sırasında Hata Oluştu",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        });
      });
    },
    stokKoduEslestir(kontrol) {
      let type = "radius";

      var vs = this.$vs;
      var vm = this;
      vm.veriler = [];
      vs.loading({
        container: `#loading-eslestir`,
        type,
      });
      try {
        const soap = require("soap");
        const url = state.sistemAddress;
        let args = [];
        if (vm.ekYetkiler == "xmlStok") {
          args = {
            token: Store.state.tokenId,
            program: vm.secilenXmlStokFirma,
            programBarkod:
              vm.secilenStok.trim() == "" ? vm.girilenStok : vm.secilenStok.trim(),
            muhasebeBarkod:
              vm.secilenXmlStok.trim() == "" ? vm.girilenstokM : vm.secilenXmlStok.trim(),
            barkod: vm.secilenStokBarcode == "" ? "" : vm.secilenStokBarcode.trim(),
          };
        } else if (kontrol == 0) {
          args = {
            token: Store.state.tokenId,
            program: vm.selectedMp.name,
            programBarkod:
              typeof vm.stokListInput.Barkod == "undefined"
                ? vm.stokListInput.trim()
                : vm.stokListInput.Barkod.trim(),
            muhasebeBarkod:
              typeof vm.xmlStokListInput.barkod == "undefined"
                ? vm.xmlStokListInput.trim()
                : vm.xmlStokListInput.barkod.trim(),
            barkod:
              typeof vm.stokListInput.Barkod == "undefined"
                ? vm.stokListInput.trim()
                : vm.stokListInput.Barkod.trim(),
          };
        } else {
          if (typeof vm.selectedMp.name == "undefined")
            vs.notify({
              title: "Pazaryeri",
              text: "Pazaryeri bilgisi eksik",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
            });
          args = {
            token: Store.state.tokenId,
            program: vm.selectedMp.name,
            programBarkod: vm.secilenXmlStokb == "" ? "" : vm.secilenXmlStokb.trim(),
            muhasebeBarkod: vm.secilenXmlStok.trim(),
            barkod: vm.barkodSecilen,
          };
        }
        soap.createClient(url, function (err, client) {
          client.pazaryeriStokKoduEsleme(args, function (err, result) {
            if (result.pazaryeriStokKoduEslemeResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.pazaryeriStokKoduEslemeResult);
              vm.stokKoduEslemeListesi();

              if (vm.ekYetkiler == "xmlStok") {
                vm.getXmlStokList();
                vm.$refs["modal-stokEkle"].hide();
                vs.loading.close("#loading-eslestir > .con-vs-loading");
              }
              vs.loading.close("#loading-eslestir > .con-vs-loading");
              vs.notify({
                title: "Stok Eşleme",
                text: "Stok Eşleme Yapıldı",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
            } catch (error) {
              vs.loading.close("#loading-eslestir > .con-vs-loading");
              vs.notify({
                title: "Stok Eşleme",
                text: "Stok Eşleme Sıradında Hata Oluştu",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          });
        });
      } catch (error) {
        vs.loading.close("#loading-eslestir > .con-vs-loading");
        console.log(error);
      }
    },

    getStokList(selectedValue) {
      var vs = this.$vs;
      var vm = this;

      vm.veriler = [];
      const soap = require("soap");
      const url = state.sistemAddress;
      let args = {
        token: Store.state.tokenId,
        kod: vm.localSelectedValue,
        barkod: "",
        AktifPazarYeriTanim: "",
        pageSize: 20,
        page: 1,
      };
      if (selectedValue && vm.localSelectedValue != selectedValue) {
        vm.localSelectedValue = selectedValue;
        args = {
          token: Store.state.tokenId,
          kod: selectedValue,
          barkod: "",
          AktifPazarYeriTanim: "",
          pageSize: 20,
          page: 1,
        };
      }
      soap.createClient(url, function (err, client) {
        client.stokListesi(args, function (err, result) {
          if (result.stokListesiResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          try {
            vm.veriler = JSON.parse(result.stokListesiResult);
            vs.loading.close();
            setTimeout(() => {
              vs.loading.close("#loading-barcode > .con-vs-loading");
            }, 1000);
            vm.stokListesi = vm.veriler;
            vm.loadingStokListValidate = false;
          } catch (error) {
            vs.loading.close();
            setTimeout(() => {
              vs.loading.close("#loading-barcode > .con-vs-loading");
            }, 1000);
          }
        });
      });
    },

    getXmlStokList() {
      var vs = this.$vs;
      var vm = this;
      vm.veriler = [];
      const soap = require("soap");
      const url = state.sistemAddress;
      if (vm.xmlStokListInput.length > 4 || vm.xmlStokListInput.length == 0) {
        const args = {
          token: Store.state.tokenId,
          barcode: vm.xmlStokListInput,
        };
        soap.createClient(url, function (err, client) {
          client.xmlStokListesiAltUrun(args, function (err, result) {
            if (result.xmlStokListesiAltUrunResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.xmlStokListesiAltUrunResult);
              vs.loading.close("#loading-material-1 > .con-vs-loading");
              vm.xmlStokListesi = vm.veriler.jsonData;
              vm.loadingXmlStokListValidate = false;
            } catch (error) {
              vs.loading.close("#loading-material-1 > .con-vs-loading");
            }
          });
        });
      }
    },
  },
  created() {
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
    this.tabList = Store.state.uzum.menuListForTabs;
    this.ekYetkiler = Store.state.ekYetkiler;
    let moduller = JSON.parse(Store.state.moduller);
    this.optionsMp = [];
    moduller.forEach((val, index) => {
      this.optionsMp.push({ name: val.marketplace });
    });
    // this.stokKoduEslemeListesi();
    this.getStokList();
    if (this.ekYetkiler == "xmlStok") this.getXmlStokList();
  },
  beforeMount() {
    this.columnDefsMarketplace = [
      {
        headerName: "Marka",
        field: "marka",
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
      },

      {
        headerName: "Stok Adı",
        sortable: true,
        filter: "agSetColumnFilter",
        field: "StokAdi",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "Barkod",
        field: "Barkod",
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "Stok Kodu",
        field: "stokKodu",
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Fiyat",
        field: "SATIS_FIAT1",
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Adet",
        field: "stokAdet",
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },

      {
        width: 100,
        field: "",
        cellRendererFramework: "StokSecButon",
        wrapText: true,
        autoHeight: true,
      },
    ];
    this.columnDefsXml = [
      {
        headerName: "Firma",
        field: "firma",
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Stok Kodu",
        sortable: true,
        filter: "agSetColumnFilter",
        field: "stokKodu",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "Stok Adı",
        sortable: true,
        filter: "agSetColumnFilter",
        field: "stokName",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "Barkod",
        field: "barkod",
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "Fiyat",
        field: "fiyat",
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Döviz",
        field: "doviz",
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Adet",
        field: "adet",
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },

      {
        width: 100,
        field: "",
        cellRendererFramework: "StokListButon",
        wrapText: true,
        autoHeight: true,
      },
    ];
  },
};
</script>

<style lang="scss">
.fill-row-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  .loading-example {
    width: 120px;
    float: left;
    height: 120px;
    box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.05);
    border-radius: 10px;
    margin: 8px;
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
      box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.05);
      transform: translate(0, 4px);
    }

    h4 {
      z-index: 40000;
      position: relative;
      text-align: center;
      padding: 10px;
    }

    &.activeLoading {
      opacity: 0 !important;
      transform: scale(0.5);
    }
  }
}

#autosuggest__input {
  outline: none;
  position: relative;
  display: block;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.con-vs-dialog {
  z-index: 520055;
}
</style>
